<template>
  <div
    ref="cell"
    class="cell-content"
    @blur="replaceEscape"
    contenteditable
    :title="editValue"
    :class="{ 'error-empty-field': isEmpty || emailInvalid }"
    @input="onInput"
  ></div>
</template>
<script>
import { validateEmail } from "@/utils";

export default {
  props: ["editing", "value", "column"],
  mounted: function () {
    this.editValue = this.value;
    this.isEmpty = !this.value ? true : false;
    this.$refs.cell.innerText = this.editValue;
    this.emailInvalid = !validateEmail(this.value);
  },
  data() {
    return {
      editValue: "",
      isEmpty: true,
      emailInvalid: true,
    };
  },
  methods: {
    onInput: function (e) {
      let value = e.target.innerText.replace(/\r?\n|\r/g, " ").trim();
      if (value.length > 255) {
        value = value.substr(0, 255);
      }

      this.emailInvalid = !validateEmail(value);

      this.editValue = value;
      this.isEmpty = e.target.innerText === "";
    },
    replaceEscape: function () {
      this.editValue = this.editValue
        ? this.editValue.replace(/\r?\n|\r/g, " ").trim()
        : "";
      this.$refs.cell.innerText = this.editValue;
      this.$emit("saveEdit", this.editValue);
    },
  },
};
</script>
<style scoped>
.cell-content {
  text-align: left;
  padding: 0 5px 0 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  min-height: 40px;
  max-width: 400px;
}

.cell-content:focus {
  background: yellow;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: visible;
}

.cell-content:not(:focus):hover {
  background: rgba(0, 0, 0, 0.2);
}

.error-empty-field {
  background-color: rgba(255, 0, 0, 0.13);
}
</style>
